import {
  characterActions,
  characterSelectors,
  Constants,
} from "@dndbeyond/character-rules-engine/es";

import {
  createCharacterActionDescriptor,
  DescribedItem,
} from "../helpers/descriptor";
import type { CharacterActionMapper } from "../middleware";

type AbilityScoreTypeSetRequestAction = ReturnType<
  typeof characterActions.abilityScoreTypeSetRequest
>;

// Labels shown in the builder's AbilityScoreTypeChooser
const METHOD_NAMES: Record<number, string> = {
  [Constants.AbilityScoreTypeEnum.STANDARD_ARRAY]: "Standard Array",
  [Constants.AbilityScoreTypeEnum.MANUAL]: "Manual/Rolled",
  [Constants.AbilityScoreTypeEnum.POINT_BUY]: "Point Buy",
};

const toItem = (method: number | null): DescribedItem | null =>
  method === null ? null : { itemId: method, name: METHOD_NAMES[method] };

/**
 * Choosing an ability score generation method. Switching methods is sent as
 * one "change".
 */
export const mapAbilityScoreTypeSet: CharacterActionMapper<
  AbilityScoreTypeSetRequestAction
> = (action, prevState) => {
  const method = action.payload.abilityScoreType;
  const previous =
    characterSelectors.getConfiguration(prevState)?.abilityScoreType ?? null;
  if (method === previous) return null;

  const changeDescriptors = createCharacterActionDescriptor(
    toItem(previous),
    toItem(method)
  );
  if (!changeDescriptors.length) return null;

  return { changeCategory: "ABILITY_SCORES_METHOD", changeDescriptors };
};
